import axiosCli from "../vue/axios/axios"

async function singIn(body, params, headers) {
    return await axiosCli.post('users/sign_in', body, {params, headers});
}

export default {
    singIn,
}